export const onderwerpen = ["Algemeen", "VSM", "Opstartplan", "TVV", "BetrokkenTreinen", "Faciliteiten", "FaciliteitenLandelijk"] as const;
export const BERICHTEN_QUERY_KEY = "berichten";
